import { render } from "./CreateOrEditInvoice.vue?vue&type=template&id=ff0f97a0&scoped=true"
import script from "./CreateOrEditInvoice.vue?vue&type=script&lang=js"
export * from "./CreateOrEditInvoice.vue?vue&type=script&lang=js"

import "./CreateOrEditInvoice.vue?vue&type=style&index=0&id=ff0f97a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff0f97a0"]])

export default __exports__